import FantasyLabsService from '../../services/fantasyLabsService';
import * as actionTypes from '../../constants/actionTypes';

export function getPlayerDetails(playerId, propsDate, sessionId) {
    return dispatch => {
        dispatch(playerDetailFetching());

        const service = new FantasyLabsService();
        service.getPlayerDetails(
            playerId,
            propsDate,
            sessionId,
            err => dispatch(playerDetailFailed(err)),
            json => dispatch(playerDetailSuccess(json))
        );
    };
}

function playerDetailFetching() {
    return {
        type: actionTypes.PLAYER_DETAILS_FETCHING
    };
}

function playerDetailSuccess(json) {
    return {
        type: actionTypes.PLAYER_DETAILS_SUCCESS,
        results: json.player_detail === null ? [] : json.player_detail
    };
}

function playerDetailFailed(err) {
    return {
        type: actionTypes.PLAYER_DETAILS_FAILED,
        errorMessage: err
    };
}



// WEBPACK FOOTER //
// ./src/redux/actions/playerDetails.js